// import { useQuery } from '@tanstack/react-query';
// import bookingServices from '../services/booking.service';

// export const useBookings = ({
//   page = 1,
//   limit = 10,
//   status,
//   bookingType,
//   paymentStatus,
//   customerId,
//   sellerId,
//   serviceId,
//   assignedStaffId,
//   startDate,
//   endDate,
//   search,
//   sortBy = 'createdAt',
//   sortOrder = 'desc',
// } = {}) => {
//   return useQuery({
//     queryKey: ['bookings', page, limit, status, bookingType, paymentStatus, customerId, sellerId, serviceId, assignedStaffId, startDate, endDate, search, sortBy, sortOrder],
//     queryFn: () =>
//       bookingServices.getBookings({
//         page,
//         limit,
//         status,
//         bookingType,
//         paymentStatus,
//         customerId,
//         sellerId,
//         serviceId,
//         assignedStaffId,
//         startDate,
//         endDate,
//         search,
//         sortBy,
//         sortOrder,
//       }),
//     staleTime: 30 * 1000, // 30 seconds
//     gcTime: 5 * 60 * 1000, // 5 minutes
//     refetchOnWindowFocus: true,
//   });
// };


import { useQuery } from '@tanstack/react-query';
import bookingServices from '../services/booking.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all bookings
 */
export const useBookings = ({
  page = 1,
  limit = 10,
  type,
  status,
  bookingType,
  paymentStatus,
  customerId,
  sellerId,
  serviceId,
  assignedStaffId,
  categoryId,
  subcategoryId,
  startDate,
  endDate,
  search,
  sortBy = 'createdAt',
  sortOrder = 'desc',
} = {}) => {
  return useQuery({
    queryKey: [
      'bookings',
      {
        page,
        limit,
        type,
        status,
        bookingType,
        paymentStatus,
        customerId,
        sellerId,
        serviceId,
        assignedStaffId,
        categoryId,
        subcategoryId,
        startDate,
        endDate,
        search,
        sortBy,
        sortOrder,
      },
    ],

    queryFn: async () => {
      try {
        return await bookingServices.getBookings({
          page,
          limit,
          status,
          bookingType,
          paymentStatus,
          customerId,
          sellerId,
          type,
          serviceId,
          assignedStaffId,
          categoryId,
          subcategoryId,
          startDate,
          endDate,
          search,
          sortBy,
          sortOrder,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,

    refetchOnWindowFocus: true,
  });
};